interface CityRegionPostalAddress {
  city?: string;
  region?: string;
  postalCode?: string;
  countryCode?: string;
}

const trimOrEmpty = (value?: string) => value?.trim() || '';

export const formatCityRegionPostal = (address: CityRegionPostalAddress): string => {
  const city = trimOrEmpty(address.city);
  const region = trimOrEmpty(address.region);
  const postalCode = trimOrEmpty(address.postalCode);
  const countryCode = trimOrEmpty(address.countryCode).toUpperCase();

  if (countryCode === 'SG') {
    return [city, region, postalCode].filter(Boolean).join(' ');
  }

  return [city, [region, postalCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
};
